import React from "react";
import { useTranslation } from "react-i18next";

import { ProjectExternalLink, projectExternalLink } from "@planzone/dto";
import {
  useAddProjectExternalLink,
  useEditProjectExternalLink,
  useRemoveProjectExternalLink,
  useRetrieveProjectExternalLinks,
} from "@planzone/view-models";
import { Props } from "./types";
import { LinkForm } from "./linkForm";
import { RemoveIcon } from "./removeIcon";
import { CloseIcon } from "./closeIcon";
import styles from "./styles.scss";

function ProjectExternalLinks({ project, close }: Props) {
  const { t } = useTranslation();
  const {
    links,
    isRequestFailure,
    isRequestSuccess,
    isRequestPending,
    retrieveProjectExternalLinks,
  } = useRetrieveProjectExternalLinks(project);
  const [externalLinks, setExternalLinks] = React.useState<
    ProjectExternalLink[]
  >(
    new Array(4).fill(projectExternalLink).map((placeholder, index) => {
      const link = links.find((l) => l.index === index);

      return link || { ...placeholder, index };
    }),
  );
  const {
    isRequestPending: isRemoveProjectExternalLinkRequestPending,
    removeProjectExternalLink,
  } = useRemoveProjectExternalLink();
  const {
    isRequestPending: isEditProjectExternalLinkRequestPending,
    editProjectExternalLink,
  } = useEditProjectExternalLink();

  React.useEffect(() => {
    !!project.uuid &&
      !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectExternalLinks(project);
  }, [project.uuid]);

  React.useEffect(() => {
    setExternalLinks(
      new Array(4).fill(projectExternalLink).map((placeholder, index) => {
        const link = links.find((l) => l.index === index);

        return link || { ...placeholder, index };
      }),
    );
  }, [links]);

  return (
    <div className={styles.projectExternalLinks}>
      <h1 className={styles.title}>{t("projectExternalLinks.title")}</h1>
      <div className={styles.main}>
        {externalLinks.map((link, index) => (
          <div className={styles.link}>
            <div className={styles.form}>
              <LinkForm
                key={index}
                project={project}
                link={link}
                editForm={(nextLink) =>
                  setExternalLinks([
                    ...externalLinks.slice(0, index),
                    nextLink,
                    ...externalLinks.slice(index + 1),
                  ])
                }
                submitForm={(nextLink) =>
                  !isEditProjectExternalLinkRequestPending &&
                  editProjectExternalLink({
                    project,
                    link,
                    nextLink,
                  })
                }
              />
            </div>
            <div
              className={styles.iconBox}
              onClick={() =>
                !isRemoveProjectExternalLinkRequestPending &&
                removeProjectExternalLink({ link, project })
              }
            >
              <RemoveIcon className={styles.icon} />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.closeIconBox} onClick={close}>
        <CloseIcon className={styles.closeIcon} />
      </div>
    </div>
  );
}

export { ProjectExternalLinks };
